module.exports = __webpack_public_path__ + "img/operationTypes.5cde4416.svg";